import { getRoute, getParking } from '@/utils/requestHandler'
import { googleMapsUrl } from '@/utils/constants/constants'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue'
import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'

export default {
   name: 'Route',
   components: {
      LoadingSpinner,
      BadRequest
   },
   data() {
      return {
         route: null,
         googleMapsUrl: googleMapsUrl,
         error: null,
         loading: true,
         stationCode: this.$route.params.code,
         parking: [],
         chosenParking: null
      }
   },
   async created() {
      await getParking(this.stationCode)
         .then(response => {
            this.station = this.$parent.station
            this.chosenParking = {
               longitude: this.station.coordinates.wgsCoordinate.longitude,
               latitude: this.station.coordinates.wgsCoordinate.latitude,
               type: 'standard',
               description: 'Route direkt zur Station'
            }
            this.parking.push(this.chosenParking)
            this.parking = this.parking.concat(response.data)
            this.loading = false
         })
         .catch(console.error)
      this.route = await getRoute(this.stationCode)
      if (typeof this.route == 'string') {
         if (this.route.includes('Request failed') || this.route.toLowerCase().includes('error')) {
            this.error = this.route
            console.log(this.error)
         }
      }

      this.loading = false
   },
   methods: {
      chooseParking(parking) {
         this.chosenParking = this.parking[parking]
      }
   }
}
